module.exports = __webpack_public_path__ + "img/dnsPanel.af7f507.svg";